import React, { cloneElement, useState } from 'react';
import  { useEffect }from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"


import { APIvar } from '../services/variables';
import styles from './Telefoni_0800_072.module.css'
import { componentStyles } from '../services/elementDesign'
const formRowGap = APIvar.formRowGap

const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});

const Telefoni_0800_072 = () => {

    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const [mreza, setMreza] = useState('')
    const [telefonRezZaOduzChecked, setTelefonRezZaOduzChecked] = useState(false);
    const [odluka, setOdluka] = useState('')
    const [datumOdluke, setDatumOdluke] = useState('')
    const [unio1, setUnio1] = useState('')
    const [unio2, setUnio2] = useState('')
    const [klasa, setKlasa] = useState('')
    const [urudzbBroj, setUrudzbBroj] = useState('')
    const [vrstaOdluke, setVrstaOdluke] = useState('')
    const [selectedStatusOption, setSelectedStatusOption] = useState('');
    const [interniVlasnik, setInterniVlasnik] = useState('')
    const [vrstaUsluge, setVrstaUsluge] = useState('')
    const [ugovor, setUgovor] = useState('')
    const [korisnik, setKorisnik] = useState('')
    const [usluga, setUsluga] = useState('')
    const [sjedisteMjesto, setSjedisteMjesto] = useState('')
    const [ptt, setPtt] = useState('')
    const [ulica, setUlica] = useState('')
    const [kbrSlovo, setKbrSlovo] = useState('')
    const [oib, setOib] = useState('')
    const [komentar, setKomentar] = useState('')
    const [datumAkcije, setDatumAkcije] = useState('')
    const [portiranje, setPortiranje] = useState('')
    const [zadnjeUklj, setZadnjeUklj] = useState('')
    const [zadnjeIsklj, setZadnjeIsklj] = useState('')
    const [zadnjaProm, setZadnjaProm] = useState('')
    const [osnovniBrojevi, setOsnovniBrojevi] = useState('')
    const [kontaktOsoba, setKontaktOsoba] = useState('')
    const [kontaktAdresa, setKontaktAdresa] = useState('')
    const [telKontakt, setTelKontakt] = useState('')
    const [email, setEmail] = useState('')
    const [racunMjesto, setRacunMjesto] = useState('')
    const [ptt2, setPtt2] = useState('')
    const [ulica2, setUlica2] = useState('')
    const [kbrSlovo2, setKbrSlovo2] = useState('')
   
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

useEffect(()=>{
        document.title="Val"
},[])

    const zadnjiBrojButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Zadnji broj")
        dispatch(actions.isNotLoading());
    }

    const odlukaPdfButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Odluka pdf")
        dispatch(actions.isNotLoading());
    }

    const handleTelefonRezZaOduzCheckboxChange = (event) => {
        setTelefonRezZaOduzChecked(event.target.checked);
    };

    const handleSelectStatusChange = (e) => {
        setSelectedStatusOption(e.target.value);
    };
    //MOCK DATA
    const statusOptions = [];

    const kopirajAdresuURacunButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Kopiraj adresu u racun")
        dispatch(actions.isNotLoading());
    }

    const pripremiZaIskljucenjeButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Pripremi za iskljucenje")
        dispatch(actions.isNotLoading());
    }

    const pregledArhiveButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Pregled arhive")
        dispatch(actions.isNotLoading());
    }

    const upitiButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Upiti ")
        dispatch(actions.isNotLoading());
    }

    const odustaniButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Odustani")
        dispatch(actions.isNotLoading());
    }

    const snimiButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Snimi")
        dispatch(actions.isNotLoading());
    }

    const krajButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Kraj")
        dispatch(actions.isNotLoading());
    }

    return (
        <ThemeProvider theme={theme}>
            <div className={styles.mainContainer}>

                {/*FORMA*/}
                <div className={styles.formContainer}>

                    {/*Prvi box*/}
                    <div className={styles.cardContainer}>

                        {/*Prvi red*/}
                        <div className={styles.redContainerDiv}>

                            <div className={styles.box1Row1Div1}>

                                <Box sx={{ width: '80%' }}>
                                                        <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                        fullWidth
                                        id="mreza_telefon"
                                        label="Mreža/Telefon"
                                        variant="outlined"
                                        value={mreza}
                                        size="medium"
                                        onChange={(event) => {
                                            setMreza(event.target.value);
                                        }}
                                    />
                                </Box>

                                <div style={{ display: 'flex', width: '20%'  }}>
                                     <Button sx={{  height:"30px", fontSize: 11 }}
                                        
                                        fullWidth
                                        size="large"
                                        variant="contained"
                                        onClick={() => {
                                            zadnjiBrojButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        Zadnji broj
                                    </Button>
                                </div>
                            </div>

                            <div className={styles.box1Row1Div2}>
                                <div style={{ width: '100%', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                                    <FormControlLabel
                                        fullWidth
                                        control={<Checkbox
                                            checked={telefonRezZaOduzChecked}
                                            onChange={handleTelefonRezZaOduzCheckboxChange}
                                        />}
                                        label={<Typography sx={{ fontSize: 16, color: "grey" }} >Telefon rezerviran za oduzimanje?</Typography>}
                                    />
                                </div>
                            </div>

                        </div>

                        {/*Opis 1*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <p style={{ color: 'grey' }}>
                                    (mreža i telefon zajedno, bez razmaka)
                                </p>
                            </div>
                        </div>

                        {/*Drugi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row2Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="odluka"
                                    label="Odluka"
                                    variant="outlined"
                                    value={odluka}
                                    onChange={(event) => {
                                        setOdluka(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row2Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="datum odluke"
                                    label="Datum odluke"
                                    variant="outlined"
                                    value={datumOdluke}
                                    onChange={(event) => {
                                        setDatumOdluke(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row2Div3}>
                                <div style={{ width: '70%', display: 'flex', gap:formRowGap}}>
                                                        <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                        fullWidth
                                        id="unio1"
                                        label="Unio"
                                        variant="outlined"
                                        value={unio1}
                                        onChange={(event) => {
                                            setUnio1(event.target.value);
                                        }}
                                    />
                                                        <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                        fullWidth
                                        id="unio2"
                                        label=""
                                        variant="outlined"
                                        value={unio2}
                                        onChange={(event) => {
                                            setUnio2(event.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', width: '30%'}}>
                                     <Button sx={{  height:"30px", fontSize: 11 }}
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            odlukaPdfButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        Odluka Pdf
                                    </Button>
                                </div>
                            </div>




                        </div>

                        {/*Treci red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row3Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="klasa"
                                    label="Klasa"
                                    variant="outlined"
                                    value={klasa}
                                    onChange={(event) => {
                                        setKlasa(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row3Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="urudzbBroj"
                                    label="Urudžba.broj"
                                    variant="outlined"
                                    value={urudzbBroj}
                                    onChange={(event) => {
                                        setUrudzbBroj(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row3Div3}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="vrstaOdluke"
                                    label="Vrsta odluke"
                                    variant="outlined"
                                    value={vrstaOdluke}
                                    onChange={(event) => {
                                        setVrstaOdluke(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Cetvrti red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row4Div1}>
                                <FormControl fullWidth>
                                    <InputLabel id="status">Status</InputLabel>
                                    <Select
                                        labelId="status"
                                        id="status-select"
                                        value={selectedStatusOption}
                                        label="Status"
                                        onChange={handleSelectStatusChange}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {statusOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className={styles.box1Row4Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="interniVlasnik"
                                    label="Interni vlasnik"
                                    variant="outlined"
                                    value={interniVlasnik}
                                    onChange={(event) => {
                                        setInterniVlasnik(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row4Div3}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="vrstaUsluge"
                                    label="Vrsta usluge"
                                    variant="outlined"
                                    value={vrstaUsluge}
                                    onChange={(event) => {
                                        setVrstaUsluge(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row4Div4}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="ugovor"
                                    label="Ugovor"
                                    variant="outlined"
                                    value={ugovor}
                                    onChange={(event) => {
                                        setUgovor(event.target.value);
                                    }}
                                />
                            </div>



                        </div>

                        {/*Opis 2*/}
                        <div style={{ display: 'flex', width: '90%', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                <p style={{ color: 'grey' }}>
                                    (naziv firme i usluge se smiju pisati i malim slovima)
                                </p>
                            </div>
                        </div>

                        {/*Peti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="korisnik"
                                    label="Korisnik"
                                    variant="outlined"
                                    value={korisnik}
                                    onChange={(event) => {
                                        setKorisnik(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Sesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="usluga"
                                    label="Usluga"
                                    variant="outlined"
                                    multiline
                                    value={usluga}
                                    onChange={(event) => {
                                        setUsluga(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Sedmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row7Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="sjedisteMjesto"
                                    label="Sjedište-Mjesto"
                                    variant="outlined"
                                    value={sjedisteMjesto}
                                    onChange={(event) => {
                                        setSjedisteMjesto(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="ptt"
                                    label="PTT"
                                    variant="outlined"
                                    value={ptt}
                                    onChange={(event) => {
                                        setPtt(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div3}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="ulica"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulica}
                                    onChange={(event) => {
                                        setUlica(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div4}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="kbrSlovo"
                                    label="Kbr/Slovo"
                                    variant="outlined"
                                    value={kbrSlovo}
                                    onChange={(event) => {
                                        setKbrSlovo(event.target.value);
                                    }}
                                />
                            </div>



                        </div>

                        {/*Osmi red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row8Div1}>

                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="oib"
                                    label="OIB"
                                    variant="outlined"
                                    value={oib}
                                    onChange={(event) => {
                                        setOib(event.target.value);
                                    }}
                                />

                            </div>
                            <div className={styles.box1Row8Div2}>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        kopirajAdresuURacunButtonFunction()
                                    }}
                                //sx={componentStyles.prihvatiButtonStyle}
                                >
                                    Kopiraj adresu u račun
                                </Button>
                            </div>
                        </div>

                        {/*Deveti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="komentar"
                                    label="Komentar"
                                    variant="outlined"
                                    multiline
                                    value={komentar}
                                    onChange={(event) => {
                                        setKomentar(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Deseti red*/}
                        <div className={styles.redContainerDiv}>

                            <div className={styles.box1Row10Div1}>

                                <div style={{ width: '80%' }}>
                                                        <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                        fullWidth
                                        id="datumAkcije"
                                        label="Datum akcije (uklj./isklj./prom./rezervacije)"
                                        variant="outlined"
                                        value={datumAkcije}
                                        onChange={(event) => {
                                            setDatumAkcije(event.target.value);
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', width: '20%' }}>
                                     <Button sx={{  height:"30px", fontSize: 11 }}
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            zadnjiBrojButtonFunction()
                                        }}
                                    //sx={componentStyles.prihvatiButtonStyle}
                                    >
                                        Zadnji broj
                                    </Button>
                                </div>

                            </div>

                            <div className={styles.box1Row10Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="portiranje"
                                    label="Portiranje"
                                    variant="outlined"
                                    value={portiranje}
                                    onChange={(event) => {
                                        setPortiranje(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Jedanaesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row11Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="zadnjeUklj"
                                    label="Zadnje Uklj"
                                    variant="outlined"
                                    value={zadnjeUklj}
                                    onChange={(event) => {
                                        setZadnjeUklj(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row11Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="zadnjeIsklj"
                                    label="Zadnje Isklj"
                                    variant="outlined"
                                    value={zadnjeIsklj}
                                    onChange={(event) => {
                                        setZadnjeIsklj(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row11Div3}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="zadnjaProm"
                                    label="Zadnja Prom"
                                    variant="outlined"
                                    value={zadnjaProm}
                                    onChange={(event) => {
                                        setZadnjaProm(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Dvanaesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ width: '100%' }}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="osnovniBrojevi"
                                    label="Osnovni brojevi"
                                    variant="outlined"
                                    multiline
                                    value={osnovniBrojevi}
                                    onChange={(event) => {
                                        setOsnovniBrojevi(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Trinaesti red*/}
                        <div className={styles.redContainerDiv}>

                            <div className={styles.box1Row13Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="kontaktOsoba"
                                    label="Kontakt Osoba"
                                    variant="outlined"
                                    value={kontaktOsoba}
                                    onChange={(event) => {
                                        setKontaktOsoba(event.target.value);
                                    }}
                                />
                            </div>

                            <div className={styles.box1Row13Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="kontaktAdresa"
                                    label="Kontakt adresa"
                                    variant="outlined"
                                    value={kontaktAdresa}
                                    onChange={(event) => {
                                        setKontaktAdresa(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Cetrnaesti red*/}
                        <div className={styles.redContainerDiv}>

                            <div className={styles.box1Row14Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="telKontakt"
                                    label="Tel. kontakt"
                                    variant="outlined"
                                    value={telKontakt}
                                    onChange={(event) => {
                                        setTelKontakt(event.target.value);
                                    }}
                                />
                            </div>

                            <div className={styles.box1Row14Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="email"
                                    label="e-mail"
                                    variant="outlined"
                                    value={email}
                                    onChange={(event) => {
                                        setEmail(event.target.value);
                                    }}
                                />
                            </div>

                        </div>

                        {/*Petnaesti red*/}
                        <div className={styles.redContainerDiv}>
                            <div className={styles.box1Row7Div1}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="racunMjesto"
                                    label="Račun-Mjesto"
                                    variant="outlined"
                                    value={racunMjesto}
                                    onChange={(event) => {
                                        setRacunMjesto(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div2}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="ptt2"
                                    label="PTT"
                                    variant="outlined"
                                    value={ptt2}
                                    onChange={(event) => {
                                        setPtt2(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div3}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="ulica2"
                                    label="Ulica"
                                    variant="outlined"
                                    value={ulica2}
                                    onChange={(event) => {
                                        setUlica2(event.target.value);
                                    }}
                                />
                            </div>
                            <div className={styles.box1Row7Div4}>
                                                    <TextField
                      InputProps={{sx:{height:30}}}
                      InputLabelProps={{
                            sx: {
                                
                                fontSize: "10px", shrink: true,
                                
                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "12px" }
                            }
                          }}
                          size="small"
                                    fullWidth
                                    id="kbrSlovo2"
                                    label="Kbr/Slovo"
                                    variant="outlined"
                                    value={kbrSlovo2}
                                    onChange={(event) => {
                                        setKbrSlovo2(event.target.value);
                                    }}
                                />
                            </div>



                        </div>


                    </div>

                    {/*BOTUNI*/}
                    <div className='button-cardPRS'>
                        <div className='main-button-containerPRS'>
                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        pripremiZaIskljucenjeButtonFunction()
                                    }}
                                 
                                >
                                    Pripremi Za Iskljucenje
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        pregledArhiveButtonFunction()
                                    }}
                                >
                                    Pregled Arhive
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        upitiButtonFunction()
                                    }}
                                >
                                    UPITI i izvještaji razni
                                </Button>
                            </div>
                        </div>

                        <div className='main-button-containerPRS'>
                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        odustaniButtonFunction()
                                    }}
                                    sx={componentStyles.odustaniButtonStyle}
                                >
                                    ODUSTANI
                                </Button>
                            </div>

                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        snimiButtonFunction()
                                    }}
                                    sx={componentStyles.snimiButtonStyle}
                                >
                                    SNIMI
                                </Button>
                            </div>
                            <div className='button-containerPRS'>
                                 <Button sx={{  height:"30px", fontSize: 11 }}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        krajButtonFunction()
                                    }}
                                    sx={componentStyles.krajButtonStyle}
                                >
                                    KRAJ
                                </Button>
                            </div>
                        </div>


                    </div>

                </div>

            </div>
        </ThemeProvider >
    );
};

export default Telefoni_0800_072;